import { startRegistration, startAuthentication, browserSupportsWebAuthn } from '@simplewebauthn/browser';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { signInWithCustomToken } from 'firebase/auth';
import { auth } from '../firebase';

const fns = () => getFunctions();

// Whether to surface passkey UI at all. Default OFF: the passkey* callables are
// IAM-403'd by the org's Domain-Restricted-Sharing policy (no allUsers invoker),
// so the flow can't complete and there's no enrollment UI to create credentials.
// Flip REACT_APP_ENABLE_PASSKEYS to "true" only once the backend is reachable.
export const passkeysEnabled = (): boolean =>
  process.env.REACT_APP_ENABLE_PASSKEYS === 'true';

export const passkeysSupported = (): boolean => browserSupportsWebAuthn();

export const registerPasskey = async (): Promise<void> => {
  const optsResp = await httpsCallable(fns(), 'passkeyRegistrationOptions')({});
  const attestation = await startRegistration({ optionsJSON: optsResp.data as any });
  const verifyResp = await httpsCallable(fns(), 'passkeyRegistrationVerify')(attestation);
  if (!(verifyResp.data as any)?.verified) {
    throw new Error('Passkey registration could not be verified.');
  }
};

export const signInWithPasskey = async (): Promise<void> => {
  const optsResp = (await httpsCallable(fns(), 'passkeyAuthenticationOptions')({})) as { data: any };
  const sessionId = optsResp.data.sessionId;
  const assertion = await startAuthentication({ optionsJSON: optsResp.data });
  const verifyResp = (await httpsCallable(fns(), 'passkeyAuthenticationVerify')({
    sessionId,
    response: assertion,
  })) as { data: { customToken: string } };
  if (!verifyResp.data?.customToken) {
    throw new Error('Passkey authentication failed.');
  }
  await signInWithCustomToken(auth, verifyResp.data.customToken);
};
